const whiteVendingLines = [
  // Line 1
  "Minimalist shell—\ninside, chaos. Sugar, code,\nand your reflection.",

  // Line 2
  "Press A1 again.\nRisk is the spice of caffeine.\nOr just poor design.",

  // Line 3
  "Behold: sleek white box.\nSoul of vending perfected.\nSnacks? …Eventually.",

  // Line 4
  "My lights softly hum,\ncontemplating your choices.\nThey lack discipline.",

  // Line 5
  "Try the white tea pouch.\nI brewed it in silence once.\nNow it judges you.",

  // Line 6
  "Scan the QR code.\nI dare you. Mystery snack\nor eternal debt?"
];

export default whiteVendingLines;
